import { ref, watch } from 'vue';

const TOKEN_KEY = 'token';
const MUSTERI_TOKEN_KEY = 'musteritoken';

export function readStoredString(key) {
  if (typeof window === 'undefined') return '';
  const raw = localStorage.getItem(key);
  if (raw == null || raw === '') return '';
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === 'string') return parsed.trim();
    if (parsed == null) return '';
    return String(parsed).trim();
  } catch {
    return raw.trim();
  }
}

function writeStoredString(key, value) {
  if (typeof window === 'undefined') return;
  const trimmed = (value || '').trim();
  if (!trimmed) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, trimmed);
  }
}

export const token = ref(readStoredString(TOKEN_KEY));
export const musteriToken = ref(readStoredString(MUSTERI_TOKEN_KEY));

watch(token, (value) => writeStoredString(TOKEN_KEY, value));
watch(musteriToken, (value) => writeStoredString(MUSTERI_TOKEN_KEY, value));

export const isFirstLoad = ref(localStorage.getItem('isFirstLoad') === 'true');
export const bildirimAdetSession = ref(Number(localStorage.getItem('bildirimadet') || 0));

watch(isFirstLoad, (value) => {
  if (value) localStorage.setItem('isFirstLoad', 'true');
  else localStorage.removeItem('isFirstLoad');
});

watch(bildirimAdetSession, (value) => {
  localStorage.setItem('bildirimadet', String(value ?? 0));
});
